import React from "react";
import styles from "./logout.module.css";
import { useNavigate } from "react-router-dom";
import { setLoggedin } from "../../../redux/userSlice";
import { useDispatch } from "react-redux";

const LogoutConfirmation = ({ onClose }) => {

  const nav = useNavigate();
  const dispatch = useDispatch();

  const handleCancel = () => {
    onClose();
  };

  const handleLogout = async () => {
    await localStorage.removeItem("token");
    dispatch(setLoggedin(false));
    onClose();
    nav("/");
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.container}>
        <h2 className={styles.title}>Logout!</h2>
        <p className={styles.message}>Are you sure you want to logout?</p>
        <div className={styles.buttonGroup}>
          <button className={styles.cancelButton} onClick={handleCancel}>
            Cancel
          </button>
          <button className={styles.logoutButton} onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutConfirmation;
